import { createFileRoute } from '@tanstack/react-router';

import { MaterialsPage } from '@/features/student/MaterialsPage';
import { requireRole } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/materials')({
  beforeLoad: () => requireRole('student'),
  component: MaterialsPage,
});
